import React from "react";
import { ArrowRightIcon } from "lucide-react";
import type { CommunityEvent } from "../../types/content";
import { SiteLink } from "../SiteLink";
type EventSummaryProps = {
  event: CommunityEvent;
};

/** Text-first event row: date, title and venue come before any imagery. */
export function EventSummary({
  event
}: EventSummaryProps) {
  return <article aria-labelledby={`event-${event.id}`} className="grid gap-5 py-8 sm:grid-cols-[auto_1fr] sm:gap-8 lg:grid-cols-[auto_1fr_auto] lg:items-center" data-id="element-34" data-mp="8p0ww4f5imeg">
      <time dateTime={event.isoStart} className="flex w-fit items-baseline gap-2 rounded-md border border-line bg-ivory px-4 py-3 text-ink sm:w-[112px] sm:flex-col sm:items-center sm:gap-0 sm:py-4" data-id="element-35" data-mp="ikawkli2uhp2">
        <span className="text-meta font-semibold text-slate" data-id="element-36" data-mp="sd097jpd61lz">{event.weekday}</span>
        <span className="text-h3 font-extrabold sm:text-[36px] sm:leading-tight" data-id="element-37" data-mp="16b6kv8nbqurk">{event.day}</span>
        <span className="text-meta font-semibold" data-id="element-38" data-mp="11d56h10ufjmf">
          {event.monthShort} {event.year}
        </span>
      </time>

      <div data-id="element-39" data-mp="2pssb613zhyf7">
        <h3 id={`event-${event.id}`} className="text-h3 font-bold text-ink" data-id="element-40" data-mp="2upr6uo3aqdfi">
          {event.title}
        </h3>
        <dl className="mt-3 grid gap-1 text-slate" data-id="element-41" data-mp="2zp3v9d9tfsk7">
          <div className="flex flex-wrap gap-x-2" data-id="element-42" data-mp="2znkab9d7stc3">
            <dt className="font-semibold text-ink" data-id="element-43" data-mp="33qyt27sjfnt8">Date:</dt>
            <dd data-id="element-44" data-mp="33ocli85nd8b0">{event.dateLabel}</dd>
          </div>
          <div className="flex flex-wrap gap-x-2" data-id="element-45" data-mp="38oihu1mv3izf">
            <dt className="font-semibold text-ink" data-id="element-46" data-mp="38nphpjierrq9">Time:</dt>
            <dd data-id="element-47" data-mp="3dnbu5qqex3y0">{event.timeLabel}</dd>
          </div>
          <div className="flex flex-wrap gap-x-2" data-id="element-48" data-mp="3ifli517yvtxn">
            <dt className="font-semibold text-ink" data-id="element-49" data-mp="3ifvauwkecf71">Venue:</dt>
            <dd data-id="element-50" data-mp="3ney31gfa2qxl">
              {event.venue}, {event.location}
            </dd>
          </div>
        </dl>
      </div>

      <SiteLink path={event.path} className="inline-flex min-h-[48px] w-fit items-center gap-2 text-label font-bold text-crimson underline underline-offset-4 hover:text-crimson-deep sm:col-start-2 lg:col-start-auto" data-id="element-51" data-mp="3rh2uc8i97bh2">
        Event details
        <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-52" data-mp="1sbjlznk0xtch" />
      </SiteLink>
    </article>;
}